import { Icon } from '@pwc/pwc-deals-ui';
import SyncedInfoLink from './SyncedInfoLink';
import './PowerPivotSyncInfo.scss';

interface IProps {
  sharePointItemUrl: string;
  name: string;
  worksheetName: string;
}

const PowerPivotSyncInfo = ({
  name = '',
  sharePointItemUrl = '',
  worksheetName = '',
}: IProps) => {
  return (
    <>
      <div className="power-pivot-sync-info">
        <Icon name="information" width="18" className="sr2 fill icon-yellow" />
        <span className="power-pivot-sync-info__msg">
          Changes made within this area are not saved.
        </span>
      </div>
      <span className="power-pivot-sync-info__link">
        Autosynced from{` '${worksheetName}'`} in{' '}
        <SyncedInfoLink name={name} url={sharePointItemUrl} />
      </span>
    </>
  );
};

export default PowerPivotSyncInfo;
